// packages/web/src/lib/websocket/index.ts
// Public API exports for WebSocket module

export { subscribeToOrderStatusUpdates, disconnectWebSocket } from './manager';